import React from "react"
import { withEducationMe } from "../../Education/lifelongLearning/withEducationMe"
import { LL_CURRENT_ENROLLMENT_QUERY } from "../../Education/lifelongLearning/queries"
import { getCurrentProgram } from "../../queries/member"
import Registration from "./Registration"
import Loading from "./Loading"
import ErrorLoading from "./ErrorLoading"
import WrapWithFetch from "../WrapWithFetch"

export const ProgramEnrollmentCard = ({
  me,
  loading,
  isFetching,
  error,
  refetch,
  reload,
}) => {
  if (loading || isFetching) {
    return <Loading />
  } else if (error) {
    return <ErrorLoading {...{ refetch, reload }} />
  }
  return <Registration {...{ me }} />
}

export default withEducationMe(
  getCurrentProgram,
  LL_CURRENT_ENROLLMENT_QUERY,
)(WrapWithFetch(ProgramEnrollmentCard))
